import React from 'react';
import './Error.css'; 
function SubmitErrorQuit() {
  return (
    <div className="submit_error wrapper">
      <h1>入力されたメールアドレスについては、既に退会済みです。</h1> 
      <div >
        <h3>入力されたメールアドレスが正しいかどうかお確かめください。</h3>
        <h3>※システム上、退会手続後、１週間ほどはメルマガが届く可能性がございますので、ご了承くださいませ。</h3>
      </div>
      <div className='error_h4'>
        <h4>らくらく連絡網カスタマーサポート：ra9-cs@eu-phoria.jp</h4>
      </div>
    </div>
  );
}
export default SubmitErrorQuit;